import { showProductAvailableModal } from '@/js/vue/composable/modal.ts';

const OPENER_SELECTOR = '.js-product-available-modal-opener';
const openerElements = document.querySelectorAll<HTMLElement>(OPENER_SELECTOR);

export function initProductAvailableModals() {
  for (const openerElement of openerElements) {
    openerElement.addEventListener('click', () => {
      const { price = '', productName = '', productId = '', productImage = '' } = openerElement.dataset;
      showProductAvailableModal(productName, productImage, price, productId);
    });
  }
}
